import { combineReducers } from 'redux';
import updateBussinesRules from './index';

const appReducer = combineReducers({
  updateBussinesRules: updateBussinesRules,
});

export default appReducer;
